import { useEffect } from 'react';

import {
  generateResourceUploadId,
  RESOURCE_CONTENT_TYPE,
  RESOURCE_STATUS,
} from 'src/data/performance';
import { PROMPT_ACTION } from 'src/data/prompt';

export const useSupportPasteEvent = ({
  rootElement,
  disablePaste,
  validateResourceLimit,
  index,
  onAction,
}) => {
  useEffect(() => {
    if (!rootElement || disablePaste) {
      return;
    }

    const handler = async (e) => {
      if (!e?.clipboardData?.files?.length) {
        return;
      }

      const pastedFile = e.clipboardData.files[0];
      // TODO: support other file resource types as well (audio/video)
      const resourceType = pastedFile.type.startsWith(RESOURCE_CONTENT_TYPE.image)
        ? RESOURCE_CONTENT_TYPE.image
        : RESOURCE_CONTENT_TYPE.document;

      if (!validateResourceLimit(resourceType)) {
        return;
      }

      // This ID is needed to track the file between several component layers
      const uploadId = generateResourceUploadId(resourceType);

      // Parent component should handle the upload
      const resource = await onAction(PROMPT_ACTION.uploadResourceFile, {
        resourceType,
        file: pastedFile,
        uploadId,
        index,
      });

      if (resource?.status === RESOURCE_STATUS.active) {
        onAction(PROMPT_ACTION.insertFileResource, {
          resource,
          skipConfirmation: true,
          uploadId,
          index,
        });
      }
    };

    rootElement.addEventListener('paste', handler);
    return () => {
      rootElement.removeEventListener('paste', handler);
    };
  }, [validateResourceLimit, disablePaste, onAction, rootElement, index]);
};
